import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Accordion, AccordionDetails, AccordionSummary, Button, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { useEffect, useState } from 'react';
import { StyledTableRow } from '../../../components/basics/StyledTableRow';
import { HeadCell, Order, TableHeaderComponent } from '../../../components/basics/TableHeaderComponent';
import { PaymentSheetListObj } from '../../../models/PaymentSheet';
import { formatPaymentSheetDate } from '../../../utils/utils';
import { usePaymentSheetsPageContext } from '../context/PaymentSheetPageContext';

const headCells: readonly HeadCell[] = [
  {
    id: 'created_at',
    align: 'left',
    disablePadding: false,
    label: 'Data da Folha',
    disableSorting: false
  },
  {
    id: 'actions',
    align: 'right',
    disablePadding: false,
    label: 'Ações',
    disableSorting: true
  }
];

interface Props {
  onView: (item: PaymentSheetListObj) => void;
}

export const PaymentSheetsTable = ({ onView }: Props) => {
  const [order, setOrder] = useState<Order>('asc');
  const [orderBy, setOrderBy] = useState<string>('username');
  const [selected, setSelected] = useState<string[]>([]);

  const [groupedItems, setGroupedItems] = useState<any>([]);

  const { payments, handleOrderChange } = usePaymentSheetsPageContext();

  const handleRequestSort = (property: string) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(String(property));
    handleOrderChange(property, isAsc ? 'desc' : 'asc');
  };

  useEffect(() => {
    setSelected([]);
    const groupItemsByYear = (items) => {
      return items.reduce((accumulator, currentItem) => {
        const year = currentItem.datafolha.trim().split(' ')[0].split('-')[2];

        if (!accumulator[year]) {
          accumulator[year] = [];
        }

        accumulator[year].push(currentItem);

        return accumulator;
      }, {});
    };

    if (payments && payments.results.length > 0) {
      const groupedItems = groupItemsByYear(payments.results);

      const sortedGroupedItems = Object.keys(groupedItems).sort((a, b) => Number(b) - Number(a));

      let orderedGroupedItems = [];
      orderedGroupedItems = sortedGroupedItems.map((year) => {
        return { [year]: groupedItems[year] };
      });

      setGroupedItems(orderedGroupedItems);
    }
  }, [payments]);

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        {groupedItems?.map((item, index) => {
          const year = Object.keys(item)?.[0];
          const values = item[year];

          return (
            <Accordion key={item + index}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                <Typography variant="subtitle1" color="primary">
                  Comprovantes de {Object.keys(item)?.[0]}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TableContainer>
                  <Table aria-labelledby="tableTitle" size={'small'}>
                    <TableHeaderComponent
                      headCells={headCells}
                      numSelected={selected?.length}
                      order={order}
                      orderBy={orderBy}
                      onSelectAllClick={() => {}}
                      onRequestSort={handleRequestSort}
                      rowCount={payments?.count || 0}
                      hideCheckbox
                    />
                    <TableBody>
                      {values?.map((row: PaymentSheetListObj, index: number) => {
                        return (
                          <StyledTableRow key={row.codigofolha + index}>
                            <TableCell align="left">{formatPaymentSheetDate(row.datafolha)}</TableCell>
                            <TableCell align="right">
                              <Button
                                size="small"
                                variant="text"
                                startIcon={<VisibilityIcon />}
                                color="primary"
                                onClick={() => onView(row)}
                              >
                                Visualizar
                              </Button>
                            </TableCell>
                          </StyledTableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Paper>
    </Box>
  );
};
